const layers = {
  base: 0,
  stage: 100,
  pane: 200,
  drawer: 300,
  content: 400,
  dock: 500,
  flyout: 600,
  globalOverlay: 690,
  dialog: 700,
  overlay: 800,
  tooltip: 900,
  alert: 1000,
} as const;

export const stateZIndexes = {
  base: 0,
  hover: layers.base + 1,
  focus: layers.base + 2,
};

export const zIndexes = {
  // Base
  base: layers.base,

  // Stage
  stage: layers.stage,

  // Panes
  pane: layers.pane,
  paneDrawer: layers.pane + 1,
  paneStuck: layers.pane + 2,
  paneSticky: layers.pane + 3,

  // Drawer
  drawer: layers.drawer,
  drawerContent: layers.drawer + 1,
  drawerWash: layers.drawer - 1,
  drawerSticky: layers.drawer + 2,

  // Content
  content: layers.content,

  // Dock
  dock: layers.dock,
  dockCore: layers.dock + 1,
  dockSidebar: layers.dock - 1,
  dockOverlay: layers.dock + 10,

  // Global alert banner
  banner: layers.flyout - 20,

  // Flyouts
  flyout: layers.flyout,

  // Minimizer
  minimizer: layers.flyout + 1,

  // Global overlays (rendered below dialogs)
  globalOverlay: layers.globalOverlay,

  // Dialogs
  dialog: layers.dialog,
  dialogContent: layers.dialog + 1,
  dialogWash: layers.dialog - 1,

  // Overlays
  overlay: layers.overlay,
  overlayContent: layers.overlay + 1,
  overlayWash: layers.overlay - 1,

  // Tooltips
  tooltip: layers.tooltip,

  // Alerts
  alert: layers.alert,
};
